module.exports = __webpack_public_path__ + "fonts/chosen-sprite.25b9acb1b504c95c6b95c33986b7317e.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/forms/chosen-sprite.png
// module id = 4
// module chunks = 9